<template>
  <div class="privacyPolicyAgreement" v-if="!isCorporate">
      <label v-if="!isHealthInsurance" v-bind:class="{'on': privacyChecked, 'privacy': !isHealthInsurance, 'disabled': isDisabled}" class="checkbox blu-checkbox is-primary">
        <input v-if="isRequired" v-bind:disabled="isDisabled" v-model='privacyChecked' type="checkbox" :name="$t('links.kvkkAgreement')" :value=privacyChecked v-validate="'required'" data-vv-validate-on="change|custom">
        <input v-if="!isRequired" v-bind:disabled="isDisabled" v-model='privacyChecked' type="checkbox" :name="$t('links.kvkkAgreement')" :value=privacyChecked>
        <span v-bind:class="{'disabled': isDisabled}">          
          <template v-if="$i18n.locale === 'tr'">
            <template v-if="!isHealthInsurance && !isKvkkPageRedirect && !isWhatsappKvkkConfirm">
              <!-- Customer KVKK Start -->
              <template v-if="interactionType !== 3">
                <modal :is-show="itemDetailShow" :show-footer=false transition="fadeDown" @close="itemDetailShow=false">
                  <div class="is-center" style="height:100%">
                    <div v-if="legalInfoText.length > 0" class='info-text' v-bind:class="{'desktop-info-text': $isDesktop}" v-html="legalInfoText[0].Body"></div>
                    <!-- <iframe id="the-iframe" @load="myFunction()" src="/bilgilendirme/kisisel-verilerin-korunmasi-kanunu-gizlilik-politikasi" width="100%" height="100%" allowfullscreen frameborder="0"></iframe> -->
                  </div>
                </modal>
                <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent="itemDetailShow = true">{{ $t("links.kvkkAgreement") }}</a> {{ $t("links.read") }}.
              </template>
              <!-- Customer KVKK End -->

              <!-- Partner KVKK Start -->
              <template v-else>
                <modal :is-show="itemDetailShow" :show-footer=false transition="fadeDown" @close="itemDetailShow=false">
                  <div class="is-center" style="height:100%">
                    <iframe id="the-iframe" :src="srcData" width="100%" height="100%" frameborder="0"></iframe>
                  </div>
                </modal>
                <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent="openPartnerKVKKAgreement">{{ $t("links.kvkkAgreement") }}</a> {{ $t("links.read") }}.
              </template>
              <!-- Partner KVKK End -->
            </template>

            <template v-if="isHealthInsurance && !isKvkkPageRedirect">
              <a v-bind:class="{'a-disabled': isDisabled}" href="https://www.eurekosigorta.com.tr/bilgilendirme/kisisel-verilerin-korunmasi-kanunu-gizlilik-politikasi" target="_blank">{{ $t("links.kvkkAgreement") }}</a>  {{ $t("links.read") }}             
            </template>

            <template v-if="isWhatsappKvkkConfirm && !isKvkkPageRedirect">
              <a v-bind:class="{'a-disabled': isDisabled}" href="https://www.eurekosigorta.com.tr/bilgilendirme/kisisel-verilerin-korunmasi-kanunu-gizlilik-politikasi" target="_blank">{{ $t("links.kvkkAgreement") }}</a>  {{ $t("links.read") }}, 
              {{ $t("links.whatsAppInfoAgreement") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openWhatsAppKvkkAgreement'>{{ $t("links.healthInfoAgreementApprove") }}</a> {{ $t("links.readAndAccepted") }}.
            </template>

            <template v-if="isKvkkPageRedirect">
              <router-link :to="{ name: 'Kvkk'}" target="_blank" rel="noreferrer">
                {{ $t("links.kvkkAgreement") }}
              </router-link>
              {{ $t("links.read") }}.
            </template>
          </template>
          <template v-if="$i18n.locale === 'en'">
            <template v-if="!isHealthInsurance && !isKvkkPageRedirect">
              <modal :is-show="itemDetailShow" :show-footer=false transition="fadeDown" @close="itemDetailShow=false">
		            <div class="is-center" style="height:100%">
                  <div v-if="legalInfoText.length > 0" class='info-text' v-bind:class="{'desktop-info-text': $isDesktop}" v-html="legalInfoText[0].Body"></div>
                  <!-- <iframe id="the-iframe" @load="myFunction()" src="/en/legal-information/general-data-protection-regulation-privacy-policy" width="100%" height="100%" allowfullscreen frameborder="0"></iframe> -->
		            </div>
	            </modal>
              {{ $t("links.read") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click="itemDetailShow = true">{{ $t("links.kvkkAgreement") }}</a>
            </template>

            <template v-if="isHealthInsurance && !isKvkkPageRedirect">
              {{ $t("links.read") }} <a v-bind:class="{'a-disabled': isDisabled}" href= "https://www.eurekosigorta.com.tr/en/legal-information/general-data-protection-regulation-privacy-policy" target="_blank"> {{ $t("links.kvkkAgreement") }}</a>
              <!-- {{ $t("links.readAndAccepted") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openHealthInfoAgreement()'>{{ $t("links.healthInfoAgreementApprove") }}</a> {{ $t("links.healthInfoAgreement") }}. -->
            </template>

            <template v-if="isKvkkPageRedirect">
              {{ $t("links.read") }} 
              <router-link :to="{ name: 'Kvkk'}" target="_blank" rel="noreferrer">
                {{ $t("links.kvkkAgreement") }}
              </router-link>
            </template>
          </template>
        </span>        
        <span v-if="errors.has($t('links.kvkkAgreement'))" class="help is-danger">{{ $t('errors.kvkkCheckBoxError') }}</span>
      </label>
      <label v-if="isHealthInsurance" v-bind:class="{'on': healthInfoAgreementChecked, 'disabled': isDisabled}" class="checkbox blu-checkbox is-primary">
        <input v-if="!isRequired" v-bind:disabled="isDisabled" v-model='healthInfoAgreementChecked' type="checkbox" :name="$t('links.kvkkAgreement') + '2'" :value=healthInfoAgreementChecked> 
        <span v-bind:class="{'disabled': isDisabled}">
          <template v-if="$i18n.locale === 'tr'">
            <template v-if="isHealthInsurance && !isKvkkPageRedirect">
              {{ $t("links.healthInfoAgreement") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openHealthInfoAgreement'>{{ $t("links.healthInfoAgreementApprove") }}</a> {{ $t("links.readAndAccepted") }}.
            </template>
          </template>
          <template v-if="$i18n.locale === 'en'">
            <template v-if="isHealthInsurance && !isKvkkPageRedirect">
              <!-- {{ $t("links.healthInfoAgreement") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openHealthInfoAgreement'>{{ $t("links.healthInfoAgreementApprove") }}</a> {{ $t("links.readAndAccepted") }}. -->
              {{ $t("links.readAndAccepted") }} <a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent='openHealthInfoAgreement()'>{{ $t("links.healthInfoAgreementApprove") }}</a> {{ $t("links.healthInfoAgreement") }}.
            </template>
          </template>
        </span>
        <span v-if="errors.has($t('links.kvkkAgreement'))" class="help is-danger">{{ $t('errors.kvkkCheckBoxError') }}</span>
      </label>
  </div>
</template>


<script>
import service from '@/service'
export default {
  name: 'PrivacyPolicyAgreement',
  components: {
  },
  data () {
    return {
      itemDetailShow: false,
      legalInfoText: '',
      legalInfoTitle: '',
      privacyChecked: (this.isPrivacyPolicyChecked && !this.isDisabled),
      healthInfoAgreementChecked: (this.isHealthInfoAgreementChecked && !this.isDisabled),
      host: 'https://www.eurekosigorta.com.tr'
    }
  },
  inject: [ 'parentValidator' ],
  created () {
    this.$validator = this.parentValidator
  },
  props: {
    isPrivacyPolicyChecked: {
      type: Boolean,
      default: true
    },
    isHealthInfoAgreementChecked: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isHealthInsurance: {
      type: Boolean,
      default: false
    },
    isWhatsappKvkkConfirm: {
      type: Boolean,
      default: false
    },
    isCorporate: {
      type: Boolean,
      default: false
    },
    isKvkkPageRedirect: {
      type: Boolean,
      default: false
    },
    interactionType: {
      type: Number,
      default: 0
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.getLegalInfo()
  },
  methods: {
    myFunction: function () {
      var iframe = document.getElementById('the-iframe')
      var elmnt
      if (this.$isDesktop) {
        elmnt = iframe.contentWindow.document.getElementById('nav')
        elmnt.style.display = 'none'
      } else {
        elmnt = iframe.contentWindow.document.getElementsByClassName('header-fixed')
        elmnt[0].style.display = 'none'
      }
    },
    getLegalInfo: function () {
      var self = this
      service.content.kvkk(self).then(function (response) {
        if (response === null) return
        self.legalInfoText = response.data.pagecategories[0].pages
        self.legalInfoTitle = response.data.pagecategories[0].pages[0].Title
      })
    },
    openWhatsAppKvkkAgreement: function () {
      var data = {
        extension: 'pdf',
        filename: 'ES_Aydinlatma_Whatsapp_Yurtdisi_Aktarim_v2_b124c6160a_4b863c9b49'
      }
      service.content.getContent(data)
    },
    openHealthInfoAgreement () {
      var data = {
        extension: 'pdf',
        filename: 'd86c49894aa5482c8dbfc4b031d873a5_e8af14dda9'
      }
      service.content.getContent(data)
    },
    openKvkkAgreement () {
      var data = {
        extension: 'pdf',
        filename: '57930afbfbe64ea0a57d81ec446d9fcf_669762b913'
      }
      service.content.getContent(data)
    },
    openHealthKvkkAgreement () {
      var data = {
        extension: 'pdf',
        filename: '5c78f1aa76854a28834aae6bdecce42c_4861eea3d4'
      }
      service.content.getContent(data)
    },
    openPartnerKVKKAgreement () {
      this.itemDetailShow = true
      var data = {
        extension: 'pdf',
        filename: '1f5d18c972e34b839172523f0c2ee9f1_2cb9d561d5'
      }
      this.srcData = service.content.contentUrl(data.extension, data.filename)
    }
  },
  computed: {
  },
  watch: {
    privacyChecked: function () {
      this.$emit('input', this.privacyChecked)
    },
    healthInfoAgreementChecked: function () {
      this.$emit('input', this.healthInfoAgreementChecked)
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: underline;
  font-size: 1em;
  font-weight: bold;
  color: var(--text-color9);
}
.privacyPolicyAgreement .privacy {
  margin-top: 30px;
}
div >>> .modal-card {
  width: 90%;
  max-width: 90%;
  height: 75%;
  max-height: 75%;
}
.info-text {
  background-color: var(--light-bg1);
  height: 100%;
  padding: 15px;
}
.info-text >>> .info-text-title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.5px;
  color: var(--text-color1);
  margin-bottom: 20px;
}
.info-text >>> .info-text-detail-paragraph {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--text-color1);
  margin-bottom: 20px;
  text-align: justify;
}
.info-text >>> .info-text-detail-paragraph ul {
  list-style: disc;
  margin-left: 16px;
}
.info-text >>> .info-text-subTitle {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.4px;
  color: var(--text-color1);
  margin-bottom: 15px;
}
.info-text >>> .letter-bullet {
  margin-left: 10px;
}
.info-text >>> .letter-bullet ol {
  counter-reset: list;
  font-weight: bold;
  color: var(--text-color1);
}
.info-text >>> .letter-bullet ol li{
  list-style: none;
  position: relative;
  margin: 10px;
}
.info-text >>> .letter-bullet ol li:before {
  counter-increment: list;
  content: counter(list, lower-alpha) ") ";
  position: absolute;
  left: -1.4em;
}
.info-text >>> .letter-bullet ol li span.label, .info-text >>> .info-text-detail-paragraph ul li span.label {
  font-weight: normal;
  color: var(--text-color1);
}
.info-text >>> .info-text-detail-paragraph .info-text-detail-subparagraph {
  margin: 15px 0 15px 0;
}
.info-text >>> .number-bullet ol {
  margin-left: 17px;
  font-weight: 600;
  color: var(--text-color1);
}
.info-text >>> .number-bullet ol li:before {
  position: absolute;
  left: -1.4em;
}
.info-text >>> .number-bullet ol li span.label {
  font-weight: normal;
  color: var(--text-color1);
}
.info-text >>> .dot-bullet ul li {
  list-style: disc;
}
.info-text >>> .dot-bullet ul {
  margin-left: 18px;
} 
.desktop-info-text {
  max-width: 970px;
  margin: 0 auto;
  padding-top: 40px;
}
.desktop-info-text.info-text >>> .info-text-title {
  font-size: 28px;
  margin-bottom: 40px;
  text-align: center;
}
.info-text >>> table{
    border-collapse: collapse;
}
.info-text >>> table thead tr th, .info-text >>> table tbody tr td{
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
}
.info-text >>> table td {
  vertical-align: middle;
}
.info-text >>> table th, .info-text >>> table td{
  padding: 4px 8px;
}
.info-text >>> .kvkk-table {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/shared/widget/legalInfo/agreement/privacyPolicy.vue